/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const groupSelector = 'collapsible-row, .facet-group';
    // The group holding the input that was just changed keeps its live DOM so the
    // click target, focus and any in-flight animation survive the refresh.
    const activeGroup = event ? event.target.closest(groupSelector) : null;

    ['#FacetFiltersForm', '#FacetFiltersFormMobile'].forEach((formSelector) => {
      const sourceForm = parsedHTML.querySelector(formSelector);
      const targetForm = document.querySelector(formSelector);
      if (!sourceForm || !targetForm) return;

      sourceForm.querySelectorAll(groupSelector).forEach((source) => {
        const index = source.dataset.index;
        if (!index) return;

        const groupAtIndex = `collapsible-row[data-index="${index}"], .facet-group[data-index="${index}"]`;
        const target = targetForm.querySelector(groupAtIndex);
        if (!target || target === activeGroup) return;

        // Swap the whole element rather than its innerHTML so custom elements inside
        // it are constructed again and keep their listeners. Going through outerHTML
        // (rather than importNode) means the fragment parser builds the subtree before
        // any custom element in it is upgraded, so their constructors see their children.
        const wasOpen = target.classList.contains('facet-group--open');
        const detailsOpen = target.querySelector('details')?.open;

        target.outerHTML = source.outerHTML;

        const replacement = targetForm.querySelector(groupAtIndex);
        if (!replacement) return;

        replacement.classList.toggle('facet-group--open', wasOpen);
        const replacementToggle = replacement.querySelector('.facet-group__toggle');
        if (replacementToggle) replacementToggle.setAttribute('aria-expanded', wasOpen);
        const replacementDetails = replacement.querySelector('details');
        if (replacementDetails && typeof detailsOpen === 'boolean') replacementDetails.open = detailsOpen;
      });
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();
    expandFacetGroupsOnDesktop();

    if (activeGroup) {
      const form = activeGroup.closest('form');
      const index = activeGroup.dataset.index;
      const countsToRender = form && index
        ? parsedHTML.querySelector(`#${form.id} collapsible-row[data-index="${index}"], #${form.id} .facet-group[data-index="${index}"]`)
        : null;
      if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, activeGroup);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    // Swapped whole so the "clear all" / hint state and the apply count both refresh.
    const footerSource = html.querySelector('.facet-drawer__footer');
    const footerTarget = document.querySelector('.facet-drawer__footer');
    if (footerSource && footerTarget) {
      footerTarget.outerHTML = footerSource.outerHTML;
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
    dispatchCustomEvent('facets:updated');
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
        dispatchCustomEvent('facets:updated');
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

/**
 *  Filter drawer interactions.
 *  Delegated from the document so they survive the drawer being re-rendered
 *  after every filter change.
 */
const facetDrawerDesktop = window.matchMedia('(min-width: 1068px)');

// The panel layout keeps every group expanded on desktop, so the markup has to agree.
function expandFacetGroupsOnDesktop() {
  if (!facetDrawerDesktop.matches) return;
  document.querySelectorAll('.facet-drawer .facet-group').forEach((group) => {
    group.classList.add('facet-group--open');
    const toggle = group.querySelector('.facet-group__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  });
}

facetDrawerDesktop.addEventListener('change', expandFacetGroupsOnDesktop);

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.facet-drawer .facet-group__toggle');
  if (toggle) {
    event.preventDefault();
    const group = toggle.closest('.facet-group');
    const open = group.classList.toggle('facet-group--open');
    toggle.setAttribute('aria-expanded', open);
    return;
  }

  // Filters are already applied as they are picked, so this just dismisses the drawer.
  if (event.target.closest('.facet-drawer .facet-drawer__apply')) {
    event.preventDefault();
    dispatchCustomEvent('panel:close');
  }
});

window.addEventListener('load', () => {
  new FacetsToggle();
  expandFacetGroupsOnDesktop();
});